import { useContext, useLayoutEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Context from '../../context';
import Container from "../global/Container";
import './index.scss';
import useKeypress from "../../hooks/useKeypress";
import BackButton from "../global/Buttons/BackButton";
import { getBackPath } from "../../helpers";
import { getEwaBackPath } from "../../libraries/ewa/helpers";
import { BACK_NAVIGATION_TYPE } from "../../helpers/constants";

const Summary = ({ type, isDocuments, data, showTitle = false, docScreenName = null }) => {
  const [closePath, setClosePath] = useState(null);
  const { itin, viewMode, customHistory, t, removeItemsFromCustomHistory } = useContext(Context);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const backButton = useRef(null);

  useLayoutEffect(() => {
    if (type !== 'gallery') return;

    let newClosePathVal = null;

    if (isDocuments) {
      const ewaBackPath = getEwaBackPath();
      newClosePathVal = (ewaBackPath?.returnTo && pathname === ewaBackPath?.entryPath) ? BACK_NAVIGATION_TYPE : getBackPath(pathname, customHistory);
    } else {
      // Find closest non-daily path
      let i = 0;
      let target;
      while (true) {
        target = customHistory[customHistory.length + i - 1];
        if (!target) {
          newClosePathVal = `/${itin.localData.urlKey}`;
          break;
        }
        if (
          (!target.match(new RegExp(`^/${itin.localData.urlKey}/gallery`, 'i')))
        ) {
          newClosePathVal = i;
          break;
        }
        i--;
      }
    }
    setClosePath(newClosePathVal);
  }, [isDocuments, pathname, customHistory, viewMode, itin.localData?.urlKey, type]);

  useLayoutEffect(()=>{
    //to allow the user scroll through the /summary section using the arrows or the Page Up and Page Down buttons
    if (viewMode === 'desktop') {
      document.querySelector(".summary-tile")?.focus();
    }
  }, [viewMode]);

  useKeypress('Escape', backButton, () => {
    if (!backButton.current) return
    backButton.current.click();
    navigate(backButton.current)
  });


  const renderTitleWithBackButton = () => (
    <div className="document-gallery-header">
      <BackButton
        className="back-button button"
        backButtonPath={closePath || -1}
        removeItemsFromCustomHistory={removeItemsFromCustomHistory}
        backButton={backButton}
      />
      <div className="title">{docScreenName}</div>
    </div>
  );

  const generateTiles = () => {
    if (isDocuments && (!data || data?.length === 0)) {
      // TODO translate. / Remove once gallery supports multiple file types
      return (
        <div className="no-images-message">
          No images available in this gallery
        </div>
      );
    }

    let currDay = 0;
    return (data || itin?.brief || []).map((x, i) => {
      let showDayNum = false;
      if (!itin.hideDays && x.day !== currDay && !x.hideDayInfo) {
        showDayNum = true;
        currDay = x.day;
      }

      const style = {};
      if (isDocuments) {
        if (!x?.file?.httpsUrl && !itin.photoNode?.file?.httpsUrl) style.backgroundColor = '#2E2F2E';
        else if (!x?.file?.mimeType.includes('image')) style.backgroundImage = `url("${itin.photoNode?.file?.httpsUrl}")`;
        else style.backgroundImage = `url("${x?.file?.httpsUrl || itin.photoNode?.file?.httpsUrl}")`;
      } else {
        const dailyPhotoNode = itin.documents.find(doc=> doc.id === x.imageNodeId);
        if (!dailyPhotoNode?.file?.httpsUrl && !itin.photoNode?.file?.httpsUrl) style.backgroundColor = '#2E2F2E';
        else style.backgroundImage = `url("${dailyPhotoNode?.file?.httpsUrl || itin.photoNode?.file?.httpsUrl}")`;
      }

      const onKeyPressed = (event) => {
        if (event.key === 'Enter') {
          navigate(isDocuments
            ? `${pathname}/gallery/${i + 1}`
            : `/${itin.localData.urlKey}/${type === 'gallery' ? 'gallery' : 'daily'}/${i+1}`);
        }
      };

      return (
        <div
          key={`summary-tile-${x.id}-${i}`}
          className="summary-tile tile-grid-tile"
          style={style}
          onClick={() => navigate(isDocuments
            ? `${pathname}/gallery/${i + 1}`
            : `/${itin.localData.urlKey}/${type === 'gallery' ? 'gallery' : 'daily'}/${i + 1}`)}
          tabIndex={0}
          onKeyDown={(event) => onKeyPressed(event)}
        >
          {
            (type !== 'gallery' || (x?.file?.mimeType && !x?.file?.mimeType?.includes('image'))) && (
              <div className="summary-tile-gradient">
                <div className="summary-tile-name">{isDocuments? x.name : x.headline}</div>
                <div className="summary-tile-day">{isDocuments? x.type : showDayNum ? t('day_format', { lng: itin.language}).replace('%d', x.day) : ''}</div>
              </div>
            )
          }
        </div>
      );
    });
  };

  return (
    <>
      <Container
        className="container-summary"
        mainElementClassName={`summary summary-${viewMode} summary-${(isDocuments && showTitle && viewMode === 'desktop') ? 'doc-gallery' : type}`}
        closePath={closePath}
        docScreenName={docScreenName}
        renderGalleryTitle={isDocuments && showTitle && viewMode === 'desktop' && renderTitleWithBackButton}
      >
        {
          isDocuments && showTitle && viewMode === 'desktop' ? (
            <div className="grid-container">
              {generateTiles()}
            </div>
          ) : (
            generateTiles()
          )
        }
      </Container>
    </>
  )
};

export default Summary;
